import React, { useState } from "react";
import Image from "../../components/Image";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthProvider";

function CurrentProducts({
  supplier = false,
  currentProducts,
  navigate,
  setIsDel,
  changeProductStatus,
}) {
  const { t, i18n } = useTranslation("productlist");
  const { userRole } = useAuth();
  const lang = i18n.language;
  let productTableHeader = [
    t("currentProducts.tableHeaders.photo"),
    t("currentProducts.tableHeaders.productName"),
    t("currentProducts.tableHeaders.supplier"),
    t("currentProducts.tableHeaders.type"),
    t("currentProducts.tableHeaders.price"),
    t("currentProducts.tableHeaders.status"),
  ];
    console.log("User Role in CurrentProducts:", userRole);

  // Add action column only if user is not viewer
  if (userRole !== 'viewer') {
    productTableHeader.push(t("currentProducts.tableHeaders.action"));
  }
  
  if (supplier) {
    productTableHeader = [
      t("currentProducts.tableHeaders.photo"),
      t("currentProducts.tableHeaders.productName"),
      t("currentProducts.tableHeaders.type"),
      t("currentProducts.tableHeaders.price"),
    ];
    
    // Add action column only if user is not viewer
    if (userRole !== 'viewer') {
      productTableHeader.push(t("currentProducts.tableHeaders.action"));
    }
  }

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [isProductActive, setIsProductActive] = useState(null);
  const toggleDropdown = (index, active) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
    setIsProductActive(active);
  };

  return (
    <div className="w-full">
      <table className="border-collapse w-full">
        <thead>
          <tr className="bg-[#ebe5ff] border-b border-[#5507cf]">
            {productTableHeader.map((item, index) => (
              <th
                key={index}
                className={`py-[10px] ${
                  index === 0 ||
                  (index === productTableHeader.length - 1 && supplier)
                    ? "w-[100px]"
                    : "w-[200px]"
                } text-center text-primary font-[400] text-[14px] ${
                  index === productTableHeader.length - 1 &&
                  supplier &&
                  "pl-[100px] pr-[30px]"
                }`}
              >
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentProducts.length === 0 && (
            <tr className="bg-white">
              <Td colspan="7">{t("currentProducts.noData")}</Td>
            </tr>
          )}
          {currentProducts.map((product, index) => (
            <tr
              key={index}
              className="bg-white border-b-2 border-b-[#EBE5FF] cursor-pointer"
              onClick={() => navigate(`/products/${product.id}`)}
            >
              <Td>
                <div className="flex items-center justify-center">
                  <Image
                    src={product.images[0]}
                    Class="h-[48px] w-[64px] rounded-lg"
                  />
                </div>
              </Td>

              <Td>{product?.name}</Td>
              {!supplier && <Td>{product?.supplier_name}</Td>}
              <Td>{product?.type}</Td>
              <Td>{product?.price}</Td>
              {!supplier && (
                <Td
                  statusStyle={
                    product?.status?.toLowerCase() === "available"
                      ? "text-[#28a745]"
                      : "text-[#dc3545]"
                  }
                >
                  {product?.status
                    ? t(`status.${product.status.toLowerCase()}`)
                    : ""}
                </Td>
              )}

              {/* Action column - only show if user is not viewer */}
              {userRole !== 'viewer' && (
                <Td>
                  <div
                    onClick={(e) => e.stopPropagation()}
                    className={`relative inline-block ${
                      supplier && "pl-[100px] pr-[30px]"
                    }`}
                  >
                    <img
                      src="/more-circle.svg"
                      alt={t("currentProducts.alt.action")}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleDropdown(index, product?.active);
                      }}
                      className="cursor-pointer"
                    />
                    {dropdownOpen === index && (
                      <div
                        className={`absolute ${
                          supplier
                            ? lang === "en"
                              ? "right-[54px]"
                              : "left-[54px]"
                            : lang === "en"
                            ? "right-6"
                            : "left-6"
                        } top-[10px] bg-white border border-[#ddd] rounded-lg shadow-md z-10 min-w-[120px]`}
                      >
                        <DropDownItem
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/products/edit-product/${product.id}`);
                          }}
                        >
                          {t("currentProducts.dropdown.edit")}
                        </DropDownItem>
                        <DropDownItem
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsDel(product.id);
                            setDropdownOpen(null);
                          }}
                        >
                          {t("currentProducts.dropdown.delete")}
                        </DropDownItem>

                        {!supplier && !isProductActive && (
                          <DropDownItem
                            onClick={() => {
                              changeProductStatus(product.id, true);
                              setDropdownOpen(null);
                            }}
                          >
                            {t("currentProducts.dropdown.activate")}
                          </DropDownItem>
                        )}
                        {!supplier && isProductActive && (
                          <DropDownItem
                            onClick={() => {
                              changeProductStatus(product.id, false);
                              setDropdownOpen(null);
                            }}
                          >
                            {t("currentProducts.dropdown.deactivate")}
                          </DropDownItem>
                        )}
                      </div>
                    )}
                  </div>
                </Td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CurrentProducts;

const Td = ({ children, statusStyle, colspan }) => (
  <td
    colSpan={colspan}
    className={`p-[10px] text-center font-[600] text-[16px] border-b-2 border-[#ebe5ff] ${
      statusStyle ? statusStyle : "text-text-medium"
    }`}
  >
    {children}
  </td>
);

const DropDownItem = ({ children, onClick }) => (
  <div
    onClick={onClick}
    className="px-3 py-2 cursor-pointer text-sm hover:bg-[#f1f1f1]"
  >
    {children}
  </div>
);
